module.exports = __webpack_public_path__ + "static/media/path2pilot-1.e2ba300c.png";